import {
    Box,
    faBook,
    faCalendarArrowDown,
    faCalendarArrowUp,
    faCalendarCheck,
    faCalendarPen,
    faFileLines,
    FontAwesomeIcon,
    Link,
    simpleDateFormatter,
    SpanTypography,
    Typography
} from ".";
import NextLink from "next/link";
import EicNotes from '@/src/components/journal-site/articles/article-meta-data/eic-notes/eic-notes';

const ArticleMetaDataComponent = (
    {
        journalTitle,
        articleMetaData,
        issueUrl
    }: {
        journalTitle: string;
        articleMetaData: any;
        issueUrl: string;
    }
) => {
    return (
        <Box
            sx={{
                '& > div': {
                    display: 'flex',
                    alignItems: 'baseline',
                    mb: .25,
                    '& span': {
                        fontSize: '.8rem',
                        '& svg': {
                            color: 'primary.main'
                        }
                    },
                    '& > span': {
                        mr: .25,
                        '&:nth-child(2)': {
                            color: 'text.secondary'
                        },
                        '&:not(:nth-child(1)):not(:nth-child(2))': {
                            fontSize: '1rem'
                        }
                    },
                    '& a': {
                        fontSize: '1rem'
                    }
                },
            }}
        >
            {
                articleMetaData.issue_id &&
                <Box>
                    <SpanTypography>
                        <FontAwesomeIcon
                            icon={faBook}
                        />
                    </SpanTypography>
                    <SpanTypography>
                        {journalTitle}:
                    </SpanTypography>
                    <Link component={NextLink} href={issueUrl} underline="hover">
                        Vol. {articleMetaData?.volume_name || ''}, issue {articleMetaData?.issue_name || ''}
                    </Link>
                    {
                        articleMetaData.first_page && articleMetaData.last_page ? (
                            <SpanTypography>
                                ; {articleMetaData.first_page}-{articleMetaData.last_page}
                            </SpanTypography>
                        ) : articleMetaData.elocation_id ? (
                            <SpanTypography color="text.secondary">
                                ; {articleMetaData.elocation_id}
                            </SpanTypography>
                        ) : null
                    }
                </Box>
            }
            {
                articleMetaData.pub_dates?.epub && (
                    <Box color="text.primary">
                        <SpanTypography>
                            <FontAwesomeIcon
                                icon={faCalendarArrowUp}
                            />
                        </SpanTypography>
                        <SpanTypography>
                            Published online:
                        </SpanTypography>
                        <SpanTypography>
                            {
                                simpleDateFormatter(
                                    articleMetaData.pub_dates.epub
                                )
                            }
                        </SpanTypography>
                    </Box>
                )
            }
            {
                articleMetaData.document_type && (
                    <Box>
                        <SpanTypography>
                            <FontAwesomeIcon
                                icon={faFileLines}
                            />
                        </SpanTypography>
                        <SpanTypography>
                            Article type:
                        </SpanTypography>
                        <SpanTypography color="text.primary">
                            {
                                articleMetaData.document_type
                            }
                        </SpanTypography>
                    </Box>
                )
            }
            {
                articleMetaData.dates?.received && (
                    <Box color="text.primary">
                        <SpanTypography>
                            <FontAwesomeIcon
                                icon={faCalendarArrowDown}
                            />
                        </SpanTypography>
                        <SpanTypography>
                            Received:
                        </SpanTypography>
                        <SpanTypography>
                            {
                                simpleDateFormatter(
                                    articleMetaData.dates.received
                                )
                            }
                        </SpanTypography>
                    </Box>
                )
            }
            {
                articleMetaData.dates?.["rev-recd"] && (
                    <Box color="text.primary">
                        <SpanTypography>
                            <FontAwesomeIcon
                                icon={faCalendarPen}
                            />
                        </SpanTypography>
                        <SpanTypography>
                            Revised:
                        </SpanTypography>
                        <SpanTypography>
                            {
                                simpleDateFormatter(
                                    articleMetaData.dates.revised
                                )
                            }
                        </SpanTypography>
                    </Box>
                )
            }
            {
                articleMetaData.dates?.accepted && (
                    <Box color="text.primary">
                        <SpanTypography>
                            <FontAwesomeIcon
                                icon={faCalendarCheck}
                            />
                        </SpanTypography>
                        <SpanTypography>
                            Accepted:
                        </SpanTypography>
                        <SpanTypography>
                            {
                                simpleDateFormatter(
                                    articleMetaData.dates.accepted
                                )
                            }
                        </SpanTypography>
                    </Box>
                )
            }
            {
                (
                    articleMetaData.desired_issue_id
                    && articleMetaData.issue_id != articleMetaData.desired_issue_id
                ) && (
                    <Box>
                        <Typography fontSize={'.875rem'}>
                            {
                                `Scheduled for ${articleMetaData?.desired_volume_name} (${articleMetaData?.desired_issue_name})`
                            }
                        </Typography>
                    </Box>
                )
            }
            {
                articleMetaData.eic_notes && (
                    <EicNotes eicNotes={articleMetaData.eic_notes} />
                )
            }
        </Box>
    )
}

export default ArticleMetaDataComponent;
